import {getPriceByQuantity} from "@Common/logic/template-options/get-price-by-quantity";

import {
    cleanItem,
    itemEditor,
}                       from "./expo-types/expo-types";
import {PaperTypeLogic} from "./paper-type-logic";

export const basicItemModules = (
    {
        templateOptions, item,
    }
) => [
    {
        name: "paperType1",
        load: ({method}, next) => PaperTypeLogic({item, templateOptions, method, next}),
        requires: ["method"],
        expo: [cleanItem],
    },
    {
        name: "paperType2",
        load: ({paperType1, paperPrices, paperPrice, totalQuantity}, next) => paperType1.next({
            paperPrices,
            paperPrice,
            totalQuantity,
            next,
        }),
        requires: ["paperType1", "paperPrices", "paperPrice", "totalQuantity"],
        expo: [
            itemEditor,
        ],
    },

    {
        name: "paperType",
        load: ({paperType1}, next) => next(paperType1.paperType),
        requires: ["paperType1"],
    },

    {
        name: "paperPrices",
        load: ({mailingClass2, method, paperType}, next) => next(
            method === "mailing" ? (
                paperType?.productPrice?.[method]?.[mailingClass2?.mailingClassId]
            ) : (
                paperType?.productPrice?.[method]
            )
        ),
        requires: ["method", "paperType"],
        requiresOptional: ["mailingClass2"],
    },
    {
        name: "paperPrice",
        load: ({paperPrices, totalQuantity}, next) => next(
            getPriceByQuantity(
                paperPrices,
                totalQuantity
            )
        ),
        requires: ["paperPrices", "totalQuantity"],
    },

];

